//syy
import React, { useState } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';


class JoinToGroupFirstPage extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        showButtonSignIn: true
      };

      this.handleSignIn = this.handleSignIn.bind(this);
      
    }
  

    handleSignIn = () => {
        this.setState({
            showButtonSignIn: false
        });
        this.props.showLogin();  
    }
    
  
    render() {
      return (
        <div className="join-to-group-first-page-container">
            <div>
                <img id="logo" alt="logo" src="img/PeaceTalk.png" />
            </div>
            <div>               
                <FormattedMessage id="partner_has_invited" defaultMessage="Your partner has invited to join to dialog"
                        description="Your partner has invited to join to dialog" />
            </div>

            <div>                
                <FormattedMessage id="partner_has_invited_s2" defaultMessage="You need Sign in for join to dialog"
                        description="You need Sign in for join to dialog" />
            </div>

            { this.state.showButtonSignIn &&
            <div className="dialog-buttons">
                <button className="primary"  onClick={() => this.handleSignIn()}>
                    <FormattedMessage id="button_sign_in" defaultMessage="Sign in"
                    description="Button [Sign In]" />
                </button>
            
            </div>}

            { !this.state.showButtonSignIn &&
            <div className="dialog-buttons">
                <FormattedMessage id="partner_has_invited_instruction" defaultMessage="<---- please Sign in in left panel"
                        description="Your partner has invited to join to dialog" />
            
            </div>}
            

        </div>
      );
    }
  }
  
  export default JoinToGroupFirstPage;
  